/**
 * Adres listy z nałożonym filtrem.
 *
 * React-admin czyta filtr z parametru `filter` jako JSON, więc kafelek musi
 * zbudować dokładnie taki adres, jakiego użyłaby lista — inaczej liczba na
 * pulpicie i zawartość widoku po kliknięciu się rozjadą.
 */
export function buildListUrl(
  resource: string,
  filter: Record<string, unknown> = {},
): string {
  const isEmpty = Object.keys(filter).length === 0;
  if (isEmpty) return `/${resource}`;
  return `/${resource}?filter=${encodeURIComponent(JSON.stringify(filter))}`;
}
